import React, { createContext, useContext, ReactNode } from "react";

type HeroSectionContextType = {
  hasLogoListBelow: boolean;
};

const HeroSectionContext = createContext<HeroSectionContextType | undefined>(
  undefined
);

export const HeroSectionProvider: React.FC<{
  children: ReactNode;
  hasLogoListBelow: boolean;
}> = ({ children, hasLogoListBelow }) => {
  return (
    <HeroSectionContext.Provider value={{ hasLogoListBelow }}>
      {children}
    </HeroSectionContext.Provider>
  );
};

export const useHeroSectionContext = () => {
  const context = useContext(HeroSectionContext);
  return context;
};
